export function definitions(modules) {
  return modules.reduce((all, module) => all.concat(module.permissions), [])
}

export function normalizeSelection(keys, modules) {
  const catalog = new Map(definitions(modules).map(item => [item.key, item]))
  const selected = new Set()
  const visiting = new Set()
  const visit = key => {
    if (!catalog.has(key)) throw new Error(`Unknown permission: ${key}. Reload the catalog.`)
    if (visiting.has(key)) throw new Error('Invalid permission dependencies. Contact support.')
    if (selected.has(key)) return
    visiting.add(key)
    catalog.get(key).requires.forEach(visit)
    visiting.delete(key)
    selected.add(key)
  }
  keys.forEach(visit)
  return [...selected].sort()
}

export function removeSelection(keys, removed, modules) {
  const remaining = new Set(keys)
  removed.forEach(key => remaining.delete(key))
  const catalog = definitions(modules)
  let changed = true
  while (changed) {
    changed = false
    catalog.forEach(item => {
      if (remaining.has(item.key) && item.requires.some(key => !remaining.has(key))) {
        remaining.delete(item.key)
        changed = true
      }
    })
  }
  return [...remaining].sort()
}

export function hasPermission(state, key) {
  return Boolean(key && state.profileSubject && state.keys.includes(key))
}
